// World units are metres. The goal line is the plane z = 0; the pitch extends towards +z.
export const BALL_R = 0.11;
export const BALL_MASS = 0.43;

export const GOAL = {
  halfWidth: 3.66, // inside edge of each post (7.32 m wide)
  height: 2.44, // underside of the crossbar
  postR: 0.06, // 12 cm posts
  depth: 2.0, // how far the box net runs back
};

export const SPOT_Z = 11; // penalty spot
export const BOARD_Z = -5.2; // advertising boards behind the goal

export const PHYS = {
  gravity: 9.81,
  drag: 0.0128, // 0.5 * rho * Cd * A / m  (Cd ~ 0.24)
  magnus: 0.0045, // lift coefficient for (spin x velocity)
  spinDecay: 0.35, // per second
  groundRestitution: 0.52,
  groundFriction: 0.22, // fraction of tangential speed lost per bounce
  rollResistance: 1.4, // m/s^2 while rolling
  postRestitution: 0.62,
  netAbsorb: 0.05, // normal speed kept after hitting the net
  netTangent: 0.45, // tangential speed kept after hitting the net
  step: 1 / 240,
};

export const SHOTS_PER_ROUND = 5;
export const GOALS_TO_ADVANCE = 3;

// Shot speed (m/s) from the power meter value 0..1.
export const SPEED_MIN = 16;
export const SPEED_MAX = 32;
export const PERFECT_ZONE = [0.68, 0.86];
export const OVERPOWER_FROM = 0.9;

// Aim limits on the goal plane (metres). Players may deliberately aim wide or high.
export const AIM_LIMITS = { minX: -5.2, maxX: 5.2, minY: 0.12, maxY: 3.5 };

export const KEEPER_NAMES = ['Rookie', 'Club Keeper', 'Pro', 'Captain', 'International', 'Legend'];
export const KEEPER_KITS = [
  { shirt: '#ff7a1a', trim: '#1a1a1a', shorts: '#1b1b1f', socks: '#ff7a1a', gloves: '#f4f4f4', strap: '#ff7a1a' },
  { shirt: '#18c7d8', trim: '#0b3b55', shorts: '#0b3b55', socks: '#18c7d8', gloves: '#ffffff', strap: '#0b3b55' },
  { shirt: '#8a4dff', trim: '#f2e94e', shorts: '#2a1a4d', socks: '#8a4dff', gloves: '#f2e94e', strap: '#2a1a4d' },
  { shirt: '#e8313f', trim: '#ffffff', shorts: '#ffffff', socks: '#e8313f', gloves: '#1d1d1d', strap: '#e8313f' },
  { shirt: '#c4f03c', trim: '#10301c', shorts: '#10301c', socks: '#c4f03c', gloves: '#10301c', strap: '#c4f03c' },
  { shirt: '#f5c542', trim: '#121212', shorts: '#121212', socks: '#121212', gloves: '#f5c542', strap: '#121212' },
];

/** Keeper ability for a 0-based round index. Values rise smoothly then plateau. */
export function keeperSkill(round) {
  const r = Math.max(0, round);
  return {
    level: r,
    name: r < KEEPER_NAMES.length ? KEEPER_NAMES[r] : `Legend +${r - KEEPER_NAMES.length + 1}`,
    kit: KEEPER_KITS[r % KEEPER_KITS.length],
    reaction: Math.max(0.1, 0.3 - 0.035 * r), // s before the keeper moves
    diveSpeed: Math.min(10.5, 5.6 + 0.85 * r), // m/s the hands can travel
    launch: Math.min(0.95, 0.35 + 0.12 * r), // extra reach from springing off the ground
    curveFooled: Math.max(0.25, 0.85 - 0.12 * r), // how much sidespin fools the first read
    adjust: 0.6 + 0.45 * r, // how quickly the keeper corrects the read in flight (1/s)
    readsPatterns: r >= 2, // starts anticipating repeated shot sides
    sway: Math.min(0.32, 0.1 + 0.045 * r), // aim reticle sway (m)
    shuffle: Math.min(0.35, 0.05 * r), // keeper's pre-shot side-to-side movement (m)
  };
}
